/**
 * App.tsx - React Router setup with all routes.
 * Generated by WebsiteGenerator.
 */
import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HeaderCard from './components/cards/HeaderCard';
import FooterCard from './components/cards/FooterCard';
import CookieConsent from './components/CookieConsent';
import HomePage from './pages/HomePage';
import ServicesPage from './pages/ServicesPage';
import TeamPage from './pages/TeamPage';
import CaseStudiesPage from './pages/CaseStudiesPage';
import ContactPage from './pages/ContactPage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
import { getConsent, onConsentChange } from './lib/consent';
import { initAnalytics } from './lib/analytics';
import { COMPANY } from './lib/company';
import './styles/theme.css';
import './styles/global.css';
import './styles/card.css';

const NAV_ITEMS = [
  { label: "Home", href: "/", cta: false },
  { label: "Services", href: "/services", cta: false },
  { label: "Our Team", href: "/team", cta: false },
  { label: "Case Studies", href: "/case-studies", cta: false },
  { label: "Get in Touch", href: "/contact", cta: true }
];

const FOOTER_SOCIAL = [{ platform: "linkedin", href: "https://linkedin.com/company/kuikentech" }];

const App: React.FC = () => {
  const year = new Date().getFullYear();
  const [showConsentBanner] = useState(() => getConsent() === null);

  // Consent gate: analytics only ever loads after an explicit "Accept all",
  // either from a prior visit (read once on mount) or a live choice made
  // in this session (via the consent-change subscription). See
  // src/lib/consent.ts and src/components/CookieConsent.tsx.
  useEffect(() => {
    if (getConsent() === 'accepted') initAnalytics();
    return onConsentChange((choice) => {
      if (choice === 'accepted') initAnalytics();
    });
  }, []);

  return (
    <Router>
      <div id="app-root" style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <HeaderCard nav={NAV_ITEMS} logoSrc="thornless_icon.png" />
        <main style={{ flex: 1 }}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/team" element={<TeamPage />} />
            <Route path="/case-studies" element={<CaseStudiesPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="*" element={<div style={{ padding: '4rem 2rem', textAlign: 'center' }}><h1>404 - Page Not Found</h1><a href="/" className="btn btn-primary" style={{ marginTop: '1rem', display: 'inline-block' }}>Go Home</a></div>} />
          </Routes>
        </main>
        <FooterCard
          company={COMPANY.tradeName}
          tagline="Making Data Beautiful Without the Thorns of Managing It."
          social={FOOTER_SOCIAL}
          copyright={`© ${year} ${COMPANY.tradeName} - a ${COMPANY.legalName} Service. All rights reserved.`}
        />
        <CookieConsent initiallyVisible={showConsentBanner} />
      </div>
    </Router>
  );
};

export default App;
